import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../Button/Button";
import m1 from "../../../assets/images/machine1.png";
import Logo from "../../../assets/images/logo_small.png";

export default function CountriesModal({ open, setOpen }) {
  const handleClose = () => setOpen(false);
  return (
    <Modal open={open} onClose={handleClose} hideBackdrop>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 726,
          height: 590,
          bgcolor: "#FFFFFF",
          boxShadow:
            "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "16px",
          outline: "none",
        }}
      >
        {" "}
        <CloseIcon
          onClick={handleClose}
          sx={{
            color: "text.primary",
            marginTop: "26px",
            marginLeft: "26px",
            marginBottom: "26px",
            "&:hover": {
              cursor: "pointer",
            },
          }}
        />
        <Box
          sx={{
            display: "flex",
            width: "100%",
            paddingX: "24px",
            height: "510px",
            columnGap: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box>
              <Typography
                variant="h3"
                fontFamily="Inter"
                fontSize="22px"
                fontWeight="600"
                lineHeight="26px"
                color="black"
                sx={{ marginBottom: "16px" }}
              >
                Embed this machinery
              </Typography>
              <Typography
                variant="body2"
                fontFamily="Inter"
                fontSize="14px"
                fontWeight="400"
                lineHeight="20px"
                color="#000000"
                sx={{ marginBottom: "16px" }}
              >
                Copy and paste the following HTML into your website code:
              </Typography>
              <Box
                sx={{
                  width: "398px",
                  height: "70.29px",
                  borderRadius: "3px",
                  border: "1px solid #BFBFBF",
                  marginBottom: "24px",
                }}
              >
                <Typography
                  variant="body2"
                  fontFamily="Inter"
                  fontSize="14px"
                  fontWeight="400"
                  lineHeight="20px"
                  color="#616161"
                  sx={{ marginLeft: "13px", marginTop: "13px" }}
                >
                  https://www.machineryplanet.com/
                </Typography>
              </Box>
              <Button
                typoVariant="body2"
                variant="outlined"
                bgColor="#FFF"
                txColor="text.primary"
                sx={{
                  height: "36px",
                  width: "111px",
                  boxShadow: "none",
                  padding: "0",
                }}
                hoverBg="text.primary"
                hoverTxColor="white"
                size="sm"
                outColor="text.primary"
                fontWeight="400"
              >
                Copy HTML
              </Button>
            </Box>
            <Typography
              variant="body2"
              fontFamily="Inter"
              fontSize="14px"
              fontWeight="400"
              lineHeight="20px"
              color="primary.main"
              sx={{
                marginBottom: "24px",
                "&:hover": {
                  cursor: "pointer",
                  textDecoration: "underline",
                },
              }}
              onClick={handleClose}
            >
              {"< Back to sharing options"}
            </Typography>
          </Box>
          <Box
            sx={{
              width: "254px",
              height: "375px",
              boxShadow:
                "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <img
              src={m1}
              width="254px"
              height="155px"
              style={{ objectFit: "cover" }}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "53px",
                height: "24px",
                backgroundColor: "text.primary",
                borderRadius: "4px",
                position: "absolute",
                top: "8px",
                right: "8px",
              }}
            >
              <Typography
                variant="caption"
                fontFamily="Inter"
                fontSize="12px"
                fontWeight="400"
                lineHeight="16px"
                color="white"
              >
                Preview
              </Typography>
            </Box>

            <Box
              sx={{ marginTop: "16px", marginBottom: "18px", marginX: "16px" }}
            >
              <Typography
                variant="subtitle1"
                fontFamily="Inter"
                fontSize="16px"
                fontWeight="600"
                lineHeight="24px"
                color="text.primary"
                sx={{ marginBottom: "16px" }}
              >
                Caterpillar 988f wheel loaders/integrated tools carriers 70
                Characters
              </Typography>
              <Line left="Years" right="2,000" />
              <Line left="Hours" right="295,000" />
              <Line left="Condition" right="Used" />
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "18px",
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="600"
                  color="primary.main"
                  sx={{
                    "&:hover": {
                      cursor: "pointer",
                      textDecoration: "underline",
                    },
                  }}
                >
                  View on Machinery Planet
                </Typography>
                <img
                  src={Logo}
                  width="30px"
                  height="24px"
                  style={{ objectFit: "cover" }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

function Line({ left, right }) {
  return (
    <Box
      sx={{ display: "flex", width: "70%", justifyContent: "space-between" }}
    >
      <Typography
        variant="body2"
        fontFamily="Inter"
        fontSize="14px"
        lineHeight="20px"
        fontWeight="400"
        color="#616161"
      >
        {left}
      </Typography>
      <Typography
        variant="subtitle2"
        fontFamily="Inter"
        fontSize="14px"
        lineHeight="20px"
        fontWeight="600"
        color="text.primary"
      >
        {right}
      </Typography>
    </Box>
  );
}
